import { GetStaticProps } from 'next';
import { getPartnersHome } from '@/common/service/api/Partners/Partners';
import { PartnersPage, PartnersPageProps } from '@/screens/PartnersPage/ui/PartnersPage';

export const getStaticProps: GetStaticProps<PartnersPageProps> = async () => {
    try {
        const getPartnerData = await getPartnersHome();

        const normaliseData = getPartnerData.map((destination) => {
            const destinationPartnersLink = destination.link
                .replace('/partners/', `/partners/${destination.state_code}/`)
                .toLowerCase();
            return {
                ...destination,
                link: destinationPartnersLink,
                partners: destination.partners.map((partner) => ({
                    ...partner,
                    url: partner.url.replace('/partners/', `${destinationPartnersLink}`),
                })),
            };
        });

        return {
            props: {
                data: normaliseData,
            },
        };
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export default PartnersPage;
